import React, { useState, useContext } from 'react';
import { NavLink, Link, useLocation } from 'react-router-dom';
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';
import { HiOutlineMenuAlt2, HiOutlineX } from "react-icons/hi";
import { FaInstagram, FaFacebook, FaLinkedinIn, FaYoutube } from "react-icons/fa";

import base from '../assets/images/header_base.png';
import base_mobile from '../assets/images/header_base_mobile.png';

import header from '../assets/images/header.jpg';
import header_es from '../assets/images/header_es.jpg';
import header_en from '../assets/images/header_en.jpg';

import br from '../assets/images/br.png';
import en from '../assets/images/en.png';
import es from '../assets/images/es.png';

import LanguageContext from '../contexts/language';
import AuthContext from '../contexts/auth';

export default function Header() {

    const { signed } = useContext(AuthContext);
    const { language, setLanguageStore } = useContext(LanguageContext);
    const lang = localStorage.getItem('language');

    function setLanguage(lang) {
        setLanguageStore(lang);
    }

    const [menu, setMenu] = useState('close');

    const location = useLocation();
    const isSubInscricaoPaths = [
        '/inscricao',
        '/inscricao-imprensa'
    ];
    const isSubPressPaths = [
        '/inscricao-imprensa'
    ];

    const isSubPanelPaths = [
        '/painelistas?dia=26',
        '/painelistas?dia=27'
    ];
      
    const isSubInscricao = isSubInscricaoPaths.some(path =>
        location.pathname.startsWith(path)
    );

    const isSubPress = isSubPressPaths.some(path =>
        location.pathname.startsWith(path)
    );

    const isSubPanel = isSubPanelPaths.some(path =>
        (location.pathname + location.search).startsWith(path)
    );

    function MyNavLink({ to, children, className }) {
        const location = useLocation();
        const isActive = (location.pathname + location.search) === to;
      
        return (
            <Link to={to} className={isActive ? `${className} active` : className} onClick={() => setMenu('close')}>
                {children}
            </Link>
        );
    }

    /*
    Home
    Agenda
    Palestrantes
    Impresa -> Inscrição Imprensa, Press Release
    Notícias
    Eventos
    Cidade de São Paulo
    Hoteis
    INSCREVA-SE
    */

    return (
        <div className="header-menu">
            <div className="header">
                <div className="social-icons-header">
                    <div className="social-icons">
                        <a href="#" className="social-icon"><FaInstagram /></a>
                        <a href="#" className="social-icon"><FaFacebook /></a>
                        <a href="#" className="social-icon"><FaLinkedinIn /></a>
                        <a href="#" className="social-icon"><FaYoutube /></a>
                    </div>
                </div>
                <Link to="/">
                    <img src={lang==='pt' ? header : lang==='en' ? header_en : header_es} className="bg-cover header-desktop1" />
                </Link>
            </div>
            <Navbar>
                <Container fluid>
                    <div className="menu-mobile" onClick={() => setMenu('open')}>
                        <HiOutlineMenuAlt2 />
                        <NavLink to="/inscricao" className="nav-link nav-login">{language.menu_inscricao}</NavLink>
                    </div>
                    <div className="menu-content-desktop">
                        <Navbar.Collapse>
                            <Nav>
                                <NavLink to="/" className={({isActive}) => isActive ? "nav-link active" : "nav-link"}>{language.menu_home}</NavLink>
                                <NavLink to="/programacao" className={({isActive}) => isActive ? "nav-link active" : "nav-link"}>{language.menu_agenda}</NavLink>
                                <NavLink to="/palestrantes" className={({isActive}) => isActive ? "nav-link active" : "nav-link"}>{language.menu_panel}</NavLink>
                                <NavLink to="/resumos" className={({isActive}) => isActive ? "nav-link active" : "nav-link"}>{language.abstracts}</NavLink>
                                {/* <div className="has-submenu">
                                    <a className={`nav-link ${isSubPress ? 'active' : ''}`}>{language.menu_imprensa}</a>
                                    <div className="submenu">
                                        <NavLink to="/inscricao-imprensa" className={({isActive}) => isActive ? "nav-link active" : "nav-link"}>{language.menu_sub_inscricao_imprensa}</NavLink>
                                        <a href="#" className="nav-link">{language.menu_imprensa_press}</a>
                                    </div>
                                </div> */}
                                {/* <NavLink to="/noticias" className={({isActive}) => isActive ? "nav-link active" : "nav-link"}>{language.menu_imprensa_material}</NavLink> */}
                                <NavLink to="/cidade-sao-paulo" className={({isActive}) => isActive ? "nav-link active" : "nav-link"}>{language.menu_sp}</NavLink>
                                <NavLink to="/hoteis" className={({isActive}) => isActive ? "nav-link active" : "nav-link"}>{language.menu_local}</NavLink>
                                <NavLink to="/inscricao" className="nav-link nav-login">{language.menu_inscricao}</NavLink>
                            </Nav>
                        </Navbar.Collapse>
                    </div>
                    <NavDropdown title={<>
                            <img src={lang==='pt' ? br : lang === 'en' ? en : es} />
                            <span>{language.language_active }</span>
                        </>} menuVariant="dark">
                        <NavDropdown.Item onClick={() => {setLanguage('pt')}}>{language.language_pt_inverse}</NavDropdown.Item>
                        <NavDropdown.Item onClick={() => {setLanguage('en')}}>{language.language_en_inverse}</NavDropdown.Item>
                        <NavDropdown.Item onClick={() => {setLanguage('es')}}>{language.language_es_inverse}</NavDropdown.Item>
                    </NavDropdown>
                </Container>
            </Navbar>
            <div className={`menu-content ${menu}`}>
                <div className="menu-mobile-close" onClick={() => setMenu('close')}>
                    <HiOutlineX />
                </div>
                <Navbar>
                    <Nav>
                        <NavLink to="/" className={({isActive}) => isActive ? "nav-link active" : "nav-link"}>{language.menu_home}</NavLink>
                        <NavLink to="/programacao" className={({isActive}) => isActive ? "nav-link active" : "nav-link"}>{language.menu_agenda}</NavLink>
                        <NavLink to="/palestrantes" className={({isActive}) => isActive ? "nav-link active" : "nav-link"}>{language.menu_panel}</NavLink>
                        <NavLink to="/resumos" className={({isActive}) => isActive ? "nav-link active" : "nav-link"}>{language.abstracts}</NavLink>
                        {/* <div className="has-submenu">
                            <a className={`nav-link ${isSubPress ? 'active' : ''}`}>{language.menu_imprensa}</a>
                            <div className="submenu">
                                <NavLink to="/inscricao-imprensa" className={({isActive}) => isActive ? "nav-link active" : "nav-link"}>{language.menu_sub_inscricao_imprensa}</NavLink>
                                <a href="#" className="nav-link">{language.menu_imprensa_press}</a>
                            </div>
                        </div> */}
                        {/* <NavLink to="/noticias" className={({isActive}) => isActive ? "nav-link active" : "nav-link"}>{language.menu_imprensa_material}</NavLink> */}
                        <NavLink to="/cidade-sao-paulo" className={({isActive}) => isActive ? "nav-link active" : "nav-link"}>{language.menu_sp}</NavLink>
                        <NavLink to="/hoteis" className={({isActive}) => isActive ? "nav-link active" : "nav-link"}>{language.menu_local}</NavLink>
                        <NavLink to="/inscricao" className="nav-link nav-login">{language.menu_inscricao}</NavLink>
                    </Nav>
                </Navbar>
            </div>
        </div>
    );
}